export const downloadFile = (response) => {
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    console.log("headers", response.headers)
    const fileName = response.headers['content-disposition']
    ? response.headers['content-disposition'].split('filename=')[1].replace(/"/g, '')
    : 'downloaded_file';

    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return fileName;
}
